module.exports = __webpack_public_path__ + "img/chat_c.9ee08c81.png";